import { takeEvery } from 'redux-saga/effects';

import * as paymentMethodsActionTypes from 'store/modules/paymentMethods/actionTypes';
import { verify } from './utils';

export default function* listenVerify() {
  yield takeEvery(paymentMethodsActionTypes.VERIFY, verify);
}
